import { Route } from "react-router-dom";

import RequireAuth from "app/router/components/RequireAuth";
import ShopManager from "pages/shopManager";
import EditItem from "pages/shopManager/EditItem";
import ShopDataRegister from "pages/shopManager/ShopDataRegister";

export function getShopManagerRoutes() {
  return (
    // HGU 샵 관리는 총학관리자 이상(auth≥3) 전용
    <Route
      element={
        <RequireAuth
          minAuth={3}
          message="총학관리자 이상만 접근할 수 있습니다."
        />
      }
    >
      <Route path="/shopManager">
        <Route index element={<ShopManager />} />
        <Route path="shopRegister" element={<ShopDataRegister />} />
        <Route path="editItem/:shopId" element={<EditItem />} />
      </Route>
    </Route>
  );
}
